import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminDirectSystemLocation } from 'src/app/constants/admin-direct-system';
import { LoginMode, LoginType } from 'src/app/constants/login-type';
import { BasePaths, MemberPaths } from 'src/app/constants/routes';
import { MultiFactorAuthenticator } from 'src/app/models/authenticator';
import { BaseMemberSession, LoginPayload, MultiMemberSelectResult } from 'src/app/models/member';
import { Session } from 'src/app/models/session';
import { AuthService } from 'src/app/services/auth.service';
import { SessionService } from 'src/app/services/storage/session.service';

@Component({
    selector: 'mwp-login',
    templateUrl: './login.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {
    public isFirsResponderLogin: boolean;
    public isFAQ: boolean;

    public loginType: LoginType;
    public loginMode = LoginMode;
    public selectedLoginMode: LoginMode;
    public title: string;
    public jsonKeyTitle: string;
    public jsonKeyMessage: string;
    public loginFormMessage: string;

    public baseMemberSession: BaseMemberSession[];
    public baseMultiMemberSelectResult: MultiMemberSelectResult;
    public baseMultiFactorAuthenticator: MultiFactorAuthenticator;

    constructor(
        private router: Router,
        private sessionService: SessionService,
        private authService: AuthService,
        private activatedRoute: ActivatedRoute,
    ) { }

    ngOnInit() {
        const jsonKeyTitlePreFix = 'loginTitle';
        const jsonKeyMessagePreFix = 'loginMessage';

        this.sessionService.session.isFaqActive = false;
        this.sessionService.setSession();
        this.sessionService.$Session.subscribe((session: Session) => {
            const l_LoginOrFaq: string = session.isFaqActive ? "FAQ" : "LOGIN";
            this.isFAQ = session.isFaqActive;

            switch (this.router.url) {
                case BasePaths.Counselors:
                    this.selectedLoginMode = LoginMode.CredenttialsCounselor;
                    this.loginType = LoginType.Counselor;
                    this.jsonKeyTitle = `${jsonKeyTitlePreFix}COUNSELOR${l_LoginOrFaq}`;
                    this.title = this.isFAQ ? `FREQUENTLY ASKED QUESTIONS - COUNSELOR LOGIN ` : "COUNSELOR LOGIN";
                    break;

                case BasePaths.Members:
                    this.selectedLoginMode = LoginMode.Credenttials;
                    this.loginType = LoginType.Member;
                    this.jsonKeyTitle = `${jsonKeyTitlePreFix}MEMBER${l_LoginOrFaq}`;
                    this.title = this.isFAQ ? `FREQUENTLY ASKED QUESTIONS - MEMBER LOGIN` : "MEMBER LOGIN";
                    break;

                case BasePaths.ResetPassword:
                    this.selectedLoginMode = LoginMode.ResetPassword;
                    this.loginType = LoginType.ResetPassword;
                    this.jsonKeyTitle = `${jsonKeyTitlePreFix}loginTitleRESETPASSSWORD`;
                    this.title = 'RESET PASSSWORD';
                    break;

                case BasePaths.Register:
                    this.selectedLoginMode = LoginMode.Registration;
                    this.loginType = LoginType.Registration;
                    this.jsonKeyTitle = `${jsonKeyTitlePreFix}Registration`;
                    this.title = 'Registration';
                    break;

                case BasePaths.AccountDeleted:
                    this.selectedLoginMode = LoginMode.AccountDeleted;
                    this.loginType = LoginType.AccountDeleted;
                    this.jsonKeyTitle = `${jsonKeyTitlePreFix}ACCOUNTDELETED`;
                    this.title = 'ACCOUNT DELETED';
                    this.jsonKeyMessage = `${jsonKeyMessagePreFix}YourAccountHasBeenDeleted`;
                    this.loginFormMessage = 'Your Account has been Deleted';
                    break;

                default:
                    if (this.router.url.startsWith(BasePaths.FirstResponders)) {
                        this.selectedLoginMode = LoginMode.Registration;
                        this.loginType = LoginType.FirstResponder;
                        this.jsonKeyTitle = `${jsonKeyTitlePreFix}FIRSTRESPONDER${l_LoginOrFaq}`;
                        this.title = this.isFAQ ? `FREQUENTLY ASKED QUESTIONS - FIRST RESPONDER LOGIN` : "FIRST RESPONDER LOGIN";
                        this.isFirsResponderLogin = true;
                    } else if (this.router.url.startsWith(BasePaths.Passthrough)) {
                        this.selectedLoginMode = LoginMode.Passthrough;
                        this.loginType = LoginType.Passthrough;
                        this.jsonKeyMessage = `${jsonKeyMessagePreFix}PleaseWaitWhileWeLogYouIn`;
                        this.loginFormMessage = 'Please wait while we log you in';
                    }
            }
        });
    }

    public buildSelectMember(event: MultiMemberSelectResult): void {
        this.baseMultiMemberSelectResult = event;
        this.baseMemberSession = event.members;
        this.selectedLoginMode = LoginMode.SelectAccount;
    }

    public cancelSelectMember(): void {
        this.baseMemberSession = null;
        this.baseMultiMemberSelectResult = null;
        this.selectedLoginMode = LoginMode.Credenttials;
    };

    public buildMFA(event: MultiFactorAuthenticator): void {
        this.baseMultiFactorAuthenticator = event;
        this.selectedLoginMode = LoginMode.MFA;
    }

    public cancelLogin(): void {
        this.selectedLoginMode = LoginMode.CredenttialsCounselor;
    }

    public redirectToLogin(): void {
        if (this.sessionService.session.isFirstResponder)
            this.router.navigateByUrl(`${BasePaths.FirstResponders}/${this.sessionService.session.firstResponderComCode}`);
        else
            this.router.navigateByUrl(BasePaths.Members);
    }

    public submitMemberSelect(event: any): void {
        const l_Payload = new LoginPayload();
        l_Payload.username = '';
        l_Payload.password = '';
        l_Payload.adminDirectSystem = AdminDirectSystemLocation.MyWorkplace;
        l_Payload.buildNumber = this.sessionService.session.operatingMode.version;
        l_Payload.systemNumber = event.systemNumber;
        l_Payload.memberid = event.id;
        l_Payload.pyid = sessionStorage.getItem('PY_ID');
        if (this.baseMultiMemberSelectResult) {
            l_Payload.reCaptchaID = this.baseMultiMemberSelectResult.reCaptchaID;
            l_Payload.reCaptchaToken = this.baseMultiMemberSelectResult.reCaptchaToken;
        }
        this.authService.selectMemberLogin(l_Payload, event).subscribe((resp) => {
            if (resp.pyidMatchedMember == true) {
                this.router.navigateByUrl(MemberPaths.PayrollPayStubs)
            } else {
                sessionStorage.removeItem('PY_ID');
                this.router.navigateByUrl(MemberPaths.Dashboard);
            }
        });
    }
}